import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/app.css';
import '@styles/scansys.css';
import '@styles/admin.css';

// Display culture is driven by the backend: auth/config.ts reads AppSettings:DefaultLocale from
// /api/publicconfig and sets window.__DEFAULT_LOCALE__. When it is not configured, getDefaultLocale()
// falls back to the browser culture. No build-time locale forcing here.

createRoot(document.getElementById('root') as HTMLElement).render(<App />);
